import React from 'react';
import {post} from '../../utils/request';
import Alert from "../../component/Alert/Alert";
import Button from "../../component/Button/Button";
import Container from "../../component/Container/Container";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";

class TokenLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            loading: true,
        };
        this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener('message', this.handleMessage);
        if (window.opener) {
            window.opener.postMessage({type: 'tokenLoginReady'}, process.env.REACT_APP_PARTNER_URL);
        } else {
            this.setState({errorMessage: "No token provided", loading: false});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    handleMessage(event) {
        if (event.origin !== process.env.REACT_APP_PARTNER_URL) {
            return;
        }
        if (event.data && event.data.type === 'loginToken' && event.data.token) {
            this.processToken(event.data.token);
        }
    }

    async processToken(token) {
        try {
            const [res, err] = await post(null, "/oneTimeLogin", {Token: token});
            if (err) {
                this.setState({errorMessage: "Invalid or expired token", loading: false});
                return;
            }
            this.props.history.push('/');
        } catch (e) {
            this.setState({errorMessage: "Invalid or expired token", loading: false});
        }
    }

    render() {
        const {errorMessage, loading} = this.state;

        if (loading) {
            return <Layout activeMenu="">
                <Container>
                    <p>Logging in...</p>
                </Container>
            </Layout>;
        }

        return <Layout activeMenu="">
            <Container>
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                <p>
                    <Link href="/signIn" label="Go to Sign In"/>
                </p>
                <p>
                    <Button className="btn secondary" label="Close Tab" onClick={() => window.close()}/>
                </p>
            </Container>
        </Layout>;
    }
}

export default TokenLogin;
